module.exports = __webpack_public_path__ + "static/img/sence-1-map.7608c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-1-map.png
// module id = jIZE
// module chunks = 1